// Dashboard-Presets: benannte Ansichten, die steuern WELCHE Dashboard-
// Sektionen sichtbar sind. Die Preset-DEFINITIONEN sind global (hier im
// Code gepflegt); die aktive AUSWAHL ist GERAETELOKAL (localStorage) --
// bewusst NICHT ueber die server-synce prefs, damit jedes Geraet sein
// eigenes Dashboard behaelt und die Wahl nicht auf alle Geraete springt.

export type DashSection = "system" | "energie" | "zuhause" | "live";

export interface DashboardPreset {
  id: string;
  /** i18n-Key + Fallback; Label wird im Consumer via t() aufgeloest. */
  labelKey: string;
  labelFallback: string;
  /** sichtbare Sektionen. Die Kritisch-Lane ist immer sichtbar (nicht
   *  Teil dieser Liste) -- kritische Alerts darf kein Preset ausblenden. */
  sections: DashSection[];
}

export const DASHBOARD_PRESETS: DashboardPreset[] = [
  {
    id: "alles",
    labelKey: "dashboard.preset.all",
    labelFallback: "Alles",
    sections: ["system", "energie", "zuhause", "live"],
  },
  {
    id: "infra",
    labelKey: "dashboard.preset.infra",
    labelFallback: "Infrastruktur",
    sections: ["system", "live"],
  },
  {
    id: "zuhause",
    labelKey: "dashboard.preset.home",
    labelFallback: "Zuhause",
    sections: ["energie", "zuhause", "live"],
  },
];

const STORAGE_KEY = "homelab-dash-active-dashboard";

function readInitial(): string {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && DASHBOARD_PRESETS.some((p) => p.id === v)) return v;
  } catch {
    // localStorage nicht verfuegbar (Privatmodus o.ae.) -- Default.
  }
  return DASHBOARD_PRESETS[0].id;
}

let activeId = $state<string>(readInitial());

/** Aktive Dashboard-Id (geraetelokal). In reaktivem Kontext aufrufen. */
export function getActiveDashboardId(): string {
  return activeId;
}

/** Setzt die aktive Dashboard-Id und persistiert sie GERAETELOKAL. */
export function setActiveDashboardId(id: string): void {
  if (!DASHBOARD_PRESETS.some((p) => p.id === id)) return;
  activeId = id;
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // ignore -- Auswahl lebt dann nur fuer diese Session.
  }
}

/** Sichtbare Sektionen des aktiven Dashboards. */
export function activeDashboardSections(): DashSection[] {
  const p = DASHBOARD_PRESETS.find((x) => x.id === activeId);
  return p ? p.sections : DASHBOARD_PRESETS[0].sections;
}
